import { isEmpty } from "@swiggy-private/js-utils";
import Blaze from "@swiggy-private/blaze.js";
import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";
import { PaymentMainProps } from "@swiggy-private/payment-client";
import { NR_TABLE_NAME } from "@swiggy-private/portal-swiggy-one-subscription-ui/dist/constants";
import { filterHeadersFromSwiggyHeaders } from "@swiggy-private/portal-swiggy-one-subscription-ui/dist/utils";

export function isApp() {
    return window.AndroidBridge || window.webkit?.messageHandlers?.nativeRequest;
}

export function isIOS() {
    if (typeof window !== "undefined") {
        return !!window.webkit?.messageHandlers?.nativeRequest;
    }
}

export function isAndroid() {
    if (typeof window !== "undefined") {
        return !!window.AndroidBridge;
    }
}

export const getPaymentHeaders = (swiggyHeaders: any, planId: string): PaymentMainProps["headers"] => {
    const paymentHeaders = {
        ...swiggyHeaders,
        [SwgyHeaderKeysList.paymentSecretKey.toLowerCase()]: process.env.NEXT_PUBLIC_PAYMENT_SECRET_KEY ?? "",
        [SwgyHeaderKeysList.planid.toLowerCase()]: planId,
        [SwgyHeaderKeysList.marketPlaceId.toLowerCase()]: "1",
        [SwgyHeaderKeysList.marketplaceCategory.toLowerCase()]: "food",
        [SwgyHeaderKeysList.marketplaceBusinessLine.toLowerCase()]: "swiggy_one",
        [SwgyHeaderKeysList.cartAddressId.toLowerCase()]: "",
    } as PaymentMainProps["headers"];

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete paymentHeaders[SwgyHeaderKeysList.marketPlaceId];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete paymentHeaders[SwgyHeaderKeysList.marketplaceCategory];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete paymentHeaders[SwgyHeaderKeysList.marketplaceBusinessLine];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete paymentHeaders?.address;

    return paymentHeaders;
};

export const overrideBrowserBack = (override: boolean, cb: VoidFunction) => {
    if (typeof window !== "undefined") {
        if (override) {
            window.onpopstate = cb;
            return;
        }
        window.onpopstate = () => true;
    }
};

export const sendCustomNREvent = (
    type: string,
    attributes: Record<string, string | number> = {},
    headers: Record<string, string | undefined> | void = {},
) => {
    const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
    const evBody = attributes ?? {};
    Blaze.recordCustomEvent({
        eventType: NR_TABLE_NAME,
        type,
        ...evBody,
        ...swgyHeaders,
    });
};

export const addChannelInfo = <T extends Record<string, unknown>>(
    obj: T,
    channel?: string,
    channelType?: string,
): T & { channel?: string; channel_type?: string } => {
    return {
        ...obj,
        ...(!isEmpty(channel) && { channel: channel }),
        ...(!isEmpty(channelType) && { channel_type: channelType }),
    };
};
